import { render, staticRenderFns } from "./loadingBox.vue?vue&type=template&id=cb77d1e2&scoped=true&"
import script from "./loadingBox.vue?vue&type=script&lang=js&"
export * from "./loadingBox.vue?vue&type=script&lang=js&"
import style0 from "./loadingBox.vue?vue&type=style&index=0&id=cb77d1e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb77d1e2",
  null
  
)

export default component.exports